import {
  Alert,
  AlertColor,
  AlertTitle,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { router } from '@inertiajs/react';
import { type JSX, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export type TFlashMessage = {
  message: string;
  type: AlertColor | null;
  subMessage?: string;
};

type Props = {
  flash: TFlashMessage;
  position?: string;
};
export const FlashMessage = ({
  flash,
  position = '268px',
}: Props): JSX.Element => {
  if (!flash.message) {
    return <></>;
  }

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (flash.message) setOpen(true);
  }, [flash]);

  // little hack that reloads flash props to prevent flash messages reappearing on navigating back/forward,
  const reloadFlashProps = (): void => router.reload({ only: ['flash'] });

  const handleClose = (): void => {
    setOpen(false);
    // reload flash props when Snackbar is either closed by pressing X button or it auto-closed due to autoHideDuration duration expiring
    reloadFlashProps();
  };

  useEffect(() => {
    // reload flash props when Snackbar is unmounted due to navigating away before autoHideDuration expired (in this case its onClose is not always fired)
    return reloadFlashProps;
  }, []);

  return (
    <Snackbar
      sx={{ left: { md: position } }}
      open={open}
      onClose={handleClose}
      message={flash.message}
      autoHideDuration={3000}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    >
      {flash.type ? (
        <Alert variant="standard" severity={flash.type}>
          {flash.subMessage ? (
            <>
              <AlertTitle>{flash.message}</AlertTitle>
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {flash.subMessage}
              </Typography>
            </>
          ) : (
            flash.message
          )}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};
